import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import MainHeader from './MainHeader';
import styles from './styles.module.scss';
import { processActionTimeTrackerTick } from '@utils/helpers';
import config from '@src/config';
import { getFeatureFlags, getConfigParameters } from '@dashboard/sagas';
import { displayErrorMessage } from '@utils/displayErrorMessage';
import { setFeatureFlags, setConfigParameters } from '@common/reducers';
import { useDimensions } from '@common/hooks/useDimensions';

let intervalId;

const MainLayout = ({ children }) => {
  const { user } = useSelector(state => state.user);
  const { isHiddenMainLayoutWrapper, headerType } = useSelector(state => state.common);
  const dispatch = useDispatch();

  useDimensions();

  useEffect(() => {
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, []);//eslint-disable-line

  useEffect(() => {
    dispatch(getFeatureFlags({
      onError: (data) => displayErrorMessage(data, 'Unable to retrieve the config.'),
      onSuccess: (data) => { /*console.log('Feature flags:', data ?? []);*/ dispatch(setFeatureFlags(data ?? [])); }
    }));

    dispatch(getConfigParameters({
      onError: (data) => displayErrorMessage(data, 'Unable to retrieve the config.'),
      onSuccess: (data) => { dispatch(setConfigParameters(data ?? [])); }
    }));

    if (!!intervalId) clearInterval(intervalId);
    intervalId = setInterval(() => {
      processActionTimeTrackerTick(user);
    }, config.TIME_LOGGER_PERIOD_SECONDS * 1000);
  }, [user]);//eslint-disable-line

  return (
    <Box className={`${styles.globalContainer} ${isHiddenMainLayoutWrapper ? styles.noBottomPadding : ''}`}>
      {!isHiddenMainLayoutWrapper && (<>
        <MainHeader />
        {headerType === 'registrationWizard' && (<Box className={styles.substrate} />)}
      </>)}
      {children}
    </Box>
  );
};

export default MainLayout;